/* SG Promotions v1: display-only automatic percentage campaigns. No cart writes or requests. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.install(root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var CONFIG = '[data-sg-promotion-config]';
  var SLOT = '[data-sg-promotion-price]';
  var ISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/;

  function timestamp(value) {
    if (!value || !String(value).trim()) return null;
    var text = String(value).trim();
    var m = ISO.exec(text);
    if (!m) return NaN;
    var y = +m[1], month = +m[2], day = +m[3], h = +m[4], min = +m[5], sec = +(m[6] || 0);
    if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(y, month, 0)).getUTCDate() || h > 23 || min > 59 || sec > 59) return NaN;
    if (m[7] !== 'Z' && (+m[7].slice(1, 3) > 23 || +m[7].slice(4) > 59)) return NaN;
    return Date.parse(text);
  }

  function compile(config) {
    var errors = [], campaigns = [];
    if (!config || config.enabled !== true) return { campaigns: campaigns, errors: ['Enable promotional displays in the SG Promotions section to show offers.'] };
    (Array.isArray(config.campaigns) ? config.campaigns : []).forEach(function (c) {
      var name = c.name || c.id || 'Unnamed campaign';
      if (c.enabled !== true) { errors.push(name + ': Enable campaign is switched off.'); return; }
      var percent = Number(c.percent), start = timestamp(c.startsAt), end = timestamp(c.endsAt);
      var products = Array.isArray(c.products) ? c.products.map(String) : [];
      var problems = [];
      if (!Number.isInteger(percent) || percent < 1 || percent > 100) problems.push('percentage must be a whole number from 1 to 100');
      if (!products.length) problems.push('select at least one product');
      if (Number.isNaN(start)) problems.push('invalid start date: use YYYY-MM-DDTHH:mm:ss+08:00 with no trailing punctuation');
      if (Number.isNaN(end)) problems.push('invalid end date: use YYYY-MM-DDTHH:mm:ss+08:00 with no trailing punctuation');
      if (start !== null && end !== null && end <= start) problems.push('end date must be after start date');
      if (problems.length) {
        errors.push(name + ': ' + problems.join('; ') + '.');
        return;
      }
      campaigns.push({ id: c.id, name: c.name, percent: percent, products: products, start: start, end: end });
    });
    return { campaigns: campaigns, errors: errors };
  }

  function resolve(campaigns, productId, now) {
    var matches = campaigns.filter(function (c) {
      return c.products.indexOf(String(productId)) !== -1 && (c.start === null || now >= c.start) && (c.end === null || now < c.end);
    });
    return { campaign: matches.length === 1 ? matches[0] : null, overlap: matches.length > 1 };
  }

  function discounted(cents, percent) {
    if (!Number.isSafeInteger(cents) || cents < 0) return null;
    // Round each unit to the nearest cent; Shopify remains authoritative at checkout.
    return Math.round(cents * (100 - percent) / 100);
  }

  function money(cents, format) {
    function amount(decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount_no_decimals': return amount(0, ',', '.');
        case 'amount_with_comma_separator': return amount(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return amount(0, '.', ',');
        case 'amount_with_apostrophe_separator': return amount(2, "'", '.');
        case 'amount_with_space_separator': return amount(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return amount(0, ' ', ',');
        default: return amount(2, ',', '.');
      }
    });
  }

  function install(win) {
    if (win.SGPromotions) { win.SGPromotions.reload(); return; }
    var doc = win.document, model = { campaigns: [], errors: [] }, states = new WeakMap();
    var timer = null, frame = null, slots = new Set(), serverAt = null, clockAt = 0;

    function now() { return serverAt === null ? Date.now() : serverAt + (win.performance.now() - clockAt); }
    function all() { return Array.from(doc.querySelectorAll(SLOT)); }
    function contextFor(el) {
      var context = el.closest('[data-main-product], [data-section-type="product-section"], .product-quickview__wrapper');
      if (context) return context;
      return Array.from(doc.querySelectorAll('[data-main-product]')).find(function (node) { return node.dataset.productId === el.dataset.productId; }) || null;
    }
    function dataFor(el) {
      var state = states.get(el);
      if (!state) {
        var script = el.querySelector('[data-sg-promotion-variants]');
        var variants = [];
        try { variants = script ? JSON.parse(script.textContent) : []; } catch (_) { /* fallback below */ }
        state = { variants: variants, signature: '' };
        states.set(el, state);
      }
      return state;
    }
    function variantFor(el, state) {
      var context = contextFor(el);
      var input = context && (context.querySelector('form.product_form .formVariantId') || context.querySelector('.formVariantId'));
      var id = input ? input.value : el.dataset.variantId;
      var variant = state.variants.find(function (v) { return String(v.id) === String(id); });
      var plan = context && context.querySelector('[name="selling_plan"]');
      if (!variant || (plan && plan.value) || variant.unit_price != null) return null;
      return variant;
    }
    function appendText(parent, className, label, value) {
      var el = doc.createElement('span');
      el.className = className;
      var hidden = doc.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = label + ' ';
      el.appendChild(hidden);
      // Money formats can contain trusted merchant HTML. Decode in an inert template.
      var template = doc.createElement('template');
      template.innerHTML = value;
      el.appendChild(doc.createTextNode(template.content.textContent));
      parent.appendChild(el);
    }
    function paint(el) {
      if (!el.isConnected) return;
      var state = dataFor(el), result = resolve(model.campaigns, el.dataset.productId, now());
      var listing = el.dataset.listing === 'true', variant = listing ? null : variantFor(el, state);
      var base = listing ? Number(el.dataset.basePrice) : variant && variant.price;
      var campaign = result.campaign;
      var sale = campaign ? discounted(base, campaign.percent) : null;
      var unsupported = el.dataset.requiresSellingPlan === 'true' || el.dataset.unitPriced === 'true';
      var active = !unsupported && sale !== null && sale < base && (listing || variant !== null);
      var soldOut = listing ? el.dataset.available === 'false' : variant && variant.available === false;
      var signature = JSON.stringify([active, base, campaign && campaign.percent, listing && el.dataset.priceVaries, result.overlap, soldOut]);
      if (signature === state.signature) return;
      state.signature = signature;
      var fallback = el.querySelector('[data-sg-promotion-fallback]');
      var output = el.querySelector('[data-sg-promotion-output]');
      if (!fallback || !output) return;
      fallback.hidden = active;
      output.hidden = !active;
      el.toggleAttribute('data-sg-promo-active', active);
      el.toggleAttribute('data-sg-promo-overlap', result.overlap);
      var card = el.closest('[data-sg-promo-card], .product-index');
      if (card) card.toggleAttribute('data-sg-promo-card-active', active);
      if (!listing && variant) {
        var compact = fallback.querySelector('[data-sg-promo-compact-base]');
        if (compact) compact.textContent = plainMoney(variant.price, el.dataset.moneyFormat);
      }
      output.replaceChildren();
      if (!active) return;
      if (listing && el.dataset.priceVaries === 'true') {
        var prefix = doc.createElement('span'); prefix.textContent = 'From '; output.appendChild(prefix);
      }
      appendText(output, 'sg-promotions-original', 'Original price', money(base, el.dataset.moneyFormat));
      appendText(output, 'sg-promotions-current', 'Promotional price', money(sale, el.dataset.moneyFormat));
      var badge = doc.createElement('span'); badge.className = 'sg-promotions-badge'; badge.textContent = 'Save ' + campaign.percent + '%'; output.appendChild(badge);
      if (soldOut) { var sold = doc.createElement('span'); sold.className = 'sg-promotions-soldout'; sold.textContent = 'Sold out'; output.appendChild(sold); }
    }
    function plainMoney(cents, format) {
      var template = doc.createElement('template'); template.innerHTML = money(cents, format); return template.content.textContent;
    }
    function schedule() {
      win.clearTimeout(timer);
      var current = now(), next = Infinity;
      model.campaigns.forEach(function (c) { [c.start, c.end].forEach(function (t) { if (t !== null && t > current) next = Math.min(next, t); }); });
      if (next !== Infinity) timer = win.setTimeout(refresh, Math.min(Math.max(next - current + 25, 25), 2147483647));
    }
    function warnings() {
      var messages = model.errors.slice();
      if (doc.querySelector('[data-sg-promo-overlap]')) messages.push('More than one active campaign targets a product. Normal pricing is shown for that product.');
      var active = model.campaigns.filter(function (c) { return (c.start === null || now() >= c.start) && (c.end === null || now() < c.end); }).length;
      var count = doc.querySelectorAll(SLOT).length;
      var status = active + ' active campaign(s). ' + count + ' connected price display(s) on this page.';
      if (!count) status += ' Open a product or collection page to check price displays.';
      if (model.campaigns.length && !active) status += ' Configured campaigns are scheduled for later or have ended.';
      doc.querySelectorAll('[data-sg-promotion-warning]').forEach(function (el) { var text = status + ' ' + messages.join(' '); if (el.textContent !== text) el.textContent = text; });
    }
    function refresh() { all().forEach(paint); schedule(); warnings(); }
    function queue(el) {
      slots.add(el);
      if (frame !== null) return;
      frame = win.requestAnimationFrame(function () { frame = null; slots.forEach(paint); slots.clear(); warnings(); });
    }
    function reload() {
      var configs = Array.from(doc.querySelectorAll(CONFIG));
      model = { campaigns: [], errors: [] };
      if (configs.length === 1) {
        try {
          var config = JSON.parse(configs[0].textContent);
          model = compile(config);
          if (serverAt === null && Number.isFinite(config.serverNow)) { serverAt = config.serverNow; clockAt = win.performance.now(); }
        } catch (_) { model.errors.push('Campaign configuration could not be read. Normal pricing is shown.'); }
      } else if (configs.length > 1) model.errors.push('Add SG Promotions only once in the footer group. Normal pricing is shown.');
      all().forEach(function (el) { states.delete(el); });
      refresh();
    }
    function refreshProduct(productId) { all().forEach(function (el) { if (el.dataset.productId === String(productId)) queue(el); }); }
    win.SGPromotions = { reload: reload, refresh: refresh, refreshProduct: refreshProduct };
    var observer = new win.MutationObserver(function (records) {
      var configChanged = false;
      records.forEach(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.closest(CONFIG)) configChanged = true;
        var fallback = target && target.closest('[data-sg-promotion-fallback]');
        if (fallback) { var host = fallback.closest(SLOT); if (host) queue(host); }
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(CONFIG) || node.querySelector(CONFIG)) configChanged = true;
          if (node.matches(SLOT)) queue(node);
          node.querySelectorAll(SLOT).forEach(queue);
        });
        record.removedNodes.forEach(function (node) { if (node.nodeType === 1 && (node.matches(CONFIG) || node.querySelector(CONFIG))) configChanged = true; });
      });
      if (configChanged) reload();
    });
    function start() {
      reload();
      observer.observe(doc.body, { childList: true, subtree: true, characterData: true });
      doc.addEventListener('change', function (event) {
        var context = event.target.closest('[data-main-product], .product-template');
        if (context) refreshProduct(context.dataset.productId);
      });
      doc.addEventListener('visibilitychange', function () { if (!doc.hidden) refresh(); });
      win.addEventListener('pageshow', refresh);
      doc.addEventListener('shopify:section:load', reload);
      doc.addEventListener('shopify:section:unload', function () { win.setTimeout(reload, 0); });
      doc.addEventListener('shopify:block:select', refresh);
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  }
  return { timestamp: timestamp, compile: compile, resolve: resolve, discounted: discounted, money: money, install: install };
});
